export default "__VITE_ASSET__da5d7848__"